<template>
  <div class="mb-3 col-sm-6 col-md-4 item" :class="{'list-group-item': displayList}">
    <div class="thumbnail card">
      <div class="img-event intrinsic">
        <img :src="itemPhoto" alt class="grow thumbnail-image card-img-top intrinsic-item p-3" />
      </div>
      <div class="card-body d-flex flex-column">
        <h5 ><span v-for="(badge, index) in badges" :key="index" class="badge badge-pill badge-info mx-1">{{ badge }}</span></h5>
        <h4 class="card-title">{{ item.name }}</h4>
        <h5 class="card-subtitle mb-2 price">
          {{ item.price | currency('Bs.', 2, {
          thousandsSeparator: ".",
          decimalSeparator: ",",
          symbolOnLeft: true,
          spaceBetweenAmountAndSymbol: true
          })
          }}
          <template
            v-if="rate"
          >
            ({{ priceUSD | currency('$', 2, {
            thousandsSeparator: ".",
            decimalSeparator: ",",
            symbolOnLeft: true,
            spaceBetweenAmountAndSymbol: true
            })
            }})
          </template>
        </h5>
        <p class="card-text truncate">{{ item.description | shortDescription}}</p>
          <div class="row align-items-end h-100" v-if="!item.needRecipe">
            <div class="col-6">
              <spinner :quantity="count" :saleLimit="item.saleLimit" @update="(value) => count = value" />
            </div>
            <div class="col-6 text-right">
              <button class="btn btn-success pull-right" @click="addItem">Añadir</button>
            </div>
          </div>
        <p v-else class="text-warning text-center font-italic">
          Este producto no puede ser adquirido online
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
const Spinner = () => import("../common/Spinner");
const allFeatures = {
  usdCurrency: 'Importado',
  deliveryPriority: 'Delivery',
  needRecipe: 'Recipe'
}
export default {
  components: {
    Spinner
  },
  props: ["item", "displayList"],
  data() {
    return {
      count: 1
    };
  },
  computed: {
    ...mapGetters(["rate"]),
    itemPhoto() {
      if (this.item.images.length) return this.item.images[0].fileNameUrl;
      else return "sin_foto.jpg";
    },
    priceUSD() {
      if (this.rate) return this.item.price / this.rate;
      else return "";
    },
    badges() {
      let features = []
      for(let feature in allFeatures){
          if(this.item[feature])
            features.push(allFeatures[feature])
      }
      return features
    }
  },
  methods: {
    ...mapActions(["updateCart"]),
    addItem() {
      let item = Object.assign({}, this.item)
      const order = {
        item,
        count: this.count,
        isAdd: true
      };
      this.count = 1;
      this.updateCart(order);
    }
  },
  filters: {
    shortDescription(value) {
      if (value && value.length > 100) {
        return value.substring(0, 100) + "...";
      } else {
        return value;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
div.card {
  height: 100%;
}

.btn-circle {
  width: 30px;
  height: 30px;
  padding: 6px 0px;
  border-radius: 15px;
  text-align: center;
  font-size: 12px;
  line-height: 1.42857;
}

.card-text {
  font-size: 0.875rem;
}

.price {
  color: green;
}

.grow {
  transition: all 0.2s ease-in-out;
}

.grow:hover {
  transform: scale(1.1);
}

.list-group-item {
  float: none;
  width: 100%;
  background-color: #fff;
  margin-bottom: 30px;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
  padding: 0 1rem;
  border: 0;
  .thumbnail {
    display: inline-block;
    width: 100%;
  }
  .img-event {
    width: 20%;
    float: left;
    padding: 0 !important;
    margin: 0;
    height: auto;
  }

  .thumbnail-image {
    position: static;
  }

  .card-body {
    float: left;
    width: 80%;
    margin: 0;
  }

  @media (max-width: 767.98px) {
    .img-event {
      width: 30%;
      float: left;
      padding: 0 !important;
      margin: 0;
    }

    .card-body {
      float: left;
      width: 70%;
      margin: 0;
    }
  }
}

.item.list-group-item:before,
.item.list-group-item:after {
  display: table;
  content: " ";
}

.item.list-group-item:after {
  clear: both;
}
</style>
